import type { Counterparty } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { CRB_COUNTERPARTIES_KEY } from 'hooks/keys';
import { useUser } from '../useUser';

type CrbCounterpartyMap = { [crbId: string]: { [counterpartyId: string]: Counterparty } };

export function useCrbCounterparties(crbIds: string[], enabled = true) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();

  const { data, isLoading: isLoadingCrbCounterparties } = useQuery<CrbCounterpartyMap>({
    enabled: enabled && crbIds.length > 0 && !!userBankId,
    queryKey: [CRB_COUNTERPARTIES_KEY, userBankId, crbIds],
    queryFn: async () => {
      return await banksApi.getCrbCounterparties(userBankId, crbIds);
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading counterparty data. Please try again, or contact support if the problem persists.'
    }
  });

  return { crbCounterpartyMap: data, isLoadingCrbCounterparties };
}
